import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  dichargeButton: {
    boxShadow: "0 0 0",
    fontSize: "1.2rem",
    borderRadius: 0,
    maxWidth: "350px",
    height: "65px",
    width: "100%",
  },
  selectionType: {
    "& h2": {
      textAlign: "center",
    },
    "& .MuiButtonBase-root": {
      minWidth: "250px",
      margin: "0 20px",
    },
  },
}));

export default useStyles;
